import gql from "graphql-tag";

export const GetQuoteHistory = gql`
  query quoteHistory(
    $brokerId: String!
    $token: String!
    $limit: Int!
    $page: Int!
    $orderBy: String
    $direction: String
    $search: String
    $clientId: String
  ) {
    QuoteHistory(
      brokerId: $brokerId
      token: $token
      limit: $limit
      page: $page
      orderBy: $orderBy
      direction: $direction
      search: $search
      clientId: $clientId
    ) {
      Count
      Results {
        id
        description
        sq_taskguid
        fk_clientID
        fk_userId
        benefits
        date_created
        fullName
        values
      }
    }
  }
`;

export const GetQuoteHistoryMedical = gql`
  query quoteHistoryMedical(
    $brokerId: String!
    $token: String!
    $limit: Int!
    $page: Int!
    $orderBy: String
    $direction: String
    $search: String
    $clientId: String
  ) {
    QuoteHistoryMedical(
      brokerId: $brokerId
      token: $token
      limit: $limit
      page: $page
      orderBy: $orderBy
      direction: $direction
      search: $search
      clientId: $clientId
    ) {
      Count
      Results {
        id
        description
        sq_taskguid
        fk_clientID
        fk_userId
        gapTarget
        date_created
        fullName
        values
      }
    }
  }
`;
export const ClientQuoteInfo = gql`
  query clientQuoteInfo(
    $brokerId: String!
    $clientId: String!
    $token: String!
    $guid: String
  ) {
    ClientQuoteInfo(
      brokerId: $brokerId
      clientId: $clientId
      token: $token
      guid: $guid
    ) {
      id
      scd_name
      scd_surname
      scd_dateOfBirth
      scd_age
      scd_title
      scd_occupation
      scd_monthlyIncome
      scd_smoker
      scd_maritalStatus
      scd_qualification
      scd_selfEmployed
      scd_salaryType
      scd_taxDispensation
      scd_spouseIncome
      scd_pAdmin
      scd_pTravel
      scd_pManual
      scd_pSupervision
      scd_gender
      scd_calculatedMonthlyIncomeAT
      scd_actualMonthlyIncomeAT
      scd_saID
      fmiOccupation
      sanlamOccupation
      doesNotQualifyForIP
      disOnlyImpairment
      formValues
      targets
      benefits
      misc_benefits
      AvailTargetsForBroker {
        id
        name
        logo
      }
    }
  }
`;

export const ClientQuoteInfoMedical = gql`
  query clientQuoteInfoMedical(
    $brokerId: String!
    $clientId: String!
    $token: String!
    $guid: String
  ) {
    ClientQuoteInfoMedical(
      brokerId: $brokerId
      clientId: $clientId
      token: $token
      guid: $guid
    ) {
      id
      scd_name
      scd_surname
      scd_dateOfBirth
      scd_age
      scd_title
      scd_occupation
      scd_monthlyIncome
      scd_smoker
      scd_maritalStatus
      scd_qualification
      scd_selfEmployed
      scd_salaryType
      scd_taxDispensation
      scd_spouseIncome
      scd_pAdmin
      scd_pTravel
      scd_pManual
      scd_pSupervision
      scd_gender
      scd_calculatedMonthlyIncomeAT
      scd_actualMonthlyIncomeAT
      fmiOccupation
      sanlamOccupation
      doesNotQualifyForIP
      disOnlyImpairment
      formValues
      targets
      benefits
      misc_benefits
      AvailTargetsForBroker {
        id
        name
        logo
      }
    }
  }
`;

export const TargetMedical = gql`
  query TargetMedical
  {
    TargetMedical
    {
      id
      name
      logo
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/quotes/queries.js